import { Paging } from '../response-models/paging.model';

/** The paging block for a list the hub sent without one: everything on a single page. */
export function singlePage(count: number): Paging {
  return { page: 1, pageSize: count, totalItems: count, totalPages: 1 };
}
